import React, {useCallback, useState} from 'react';
import ToggleComponent from "v4/components/utils/ToggleComponent/ToggleComponent";
import ProspectHeadingTabPartial
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/ProspectHeadingTabPartial/ProspectHeadingTabPartial";
import ProspectQuotesDuplicate
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/ProspectQuotesDuplicate/ProspectQuotesDuplicate";
import ProspectQuotesTabPartial
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/ProspectQuotesTabPartial/ProspectQuotesTabPartial";
import ProspectQuotesCustomTabActions
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectQuotesCustomTab/components/ProspectQuotesCustomTabActions/ProspectQuotesCustomTabActions";
import ProspectQuotesCustomTabRowActions
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectQuotesCustomTab/components/ProspectQuotesCustomTabRowActions/ProspectQuotesCustomTabRowActions";

export default function ProspectQuotesCustomTabListing({prospectId, currentRoute}) {
    const [rowIdToDuplicate, setRowIdToDuplicate] = useState(null);

    const handleDuplicate = (rowId) => () => setRowIdToDuplicate(rowId);

    const closeDuplicatePopup = useCallback(() => setRowIdToDuplicate(null), [setRowIdToDuplicate]);

    return (
        <>
            <div className="prospect-tab__listing__wrapper">
                <ProspectHeadingTabPartial actions={(props) => <ProspectQuotesCustomTabActions {...props}/>}/>
                <ProspectQuotesTabPartial fetchParams={{tabId: currentRoute.route.metadata.tab_id}}
                                          prospectId={prospectId}
                                          rowActions={
                                              <ProspectQuotesCustomTabRowActions onDuplicate={handleDuplicate}/>
                                          }/>
            </div>

            <ToggleComponent isShowing={rowIdToDuplicate} shouldRemoveFromDom={true} className="duplicate-popup">
                <ProspectQuotesDuplicate rowIdToDuplicate={rowIdToDuplicate} closePopup={closeDuplicatePopup}/>
            </ToggleComponent>
        </>
    )
}
